import { VehicleTypeEnum } from "../enums/vehicle-type-enum";
import { Plant } from './plant';

export class Vehicle {
  id?: number;
  name?: string;
  registerNumber?: string;
  capacity?: number;
  color?: string;
  vehicleType?: VehicleTypeEnum;
  plant?: Plant;

}
